import {
  AUTH_STATUS_APPROVE,
  AUTH_STATUS_NEW,
  AUTH_STATUS_PROGRESSING,
} from "constants/FormatDataContanst";
import { convertToDD_MM_YYY } from "helpers/utils";

export const getReportStatus = t => {
  const AUTH_STATUS = {
    [AUTH_STATUS_NEW]: {
      //"Lưu tạm",
      text: t("auth_status_report.m"),
      badgeColor: "badge-soft-primary",
    },
    [AUTH_STATUS_PROGRESSING]: {
      text: t("auth_status_report.p"),
      badgeColor: "badge-soft-warning",
    },
    [AUTH_STATUS_APPROVE]: {
      text: t("auth_status_report.a"),
      badgeColor: "badge-soft-success",
    },
  };

  return {
    AUTH_STATUS: AUTH_STATUS,
  };
};

export const getTimeContent = cellContent => {
  if (cellContent.month) {
    return `Tháng ${cellContent.month}_${cellContent.year}`;
  }
  if (cellContent.quarter) {
    return `Quý ${cellContent.quarter}_${cellContent.year}`;
  }
  if (cellContent.date && cellContent.date.length === 2) {
    return `${convertToDD_MM_YYY(cellContent.date[0])} ~ ${convertToDD_MM_YYY(
      cellContent.date[1]
    )}`;
  }
  if (cellContent.date_from && cellContent.date_to) {
    return `${convertToDD_MM_YYY(
      cellContent.date_from,
      "_"
    )}_${convertToDD_MM_YYY(cellContent.date_to, "_")}`;
  }
};

export const TYPE_REPORT = {
  ERROR: "ERROR", // type 10,
  DATA: 1, // Bảng kê dữ liệu hóa đơn,
  USE: 2, // Bảng kê tình hình sử dụng
  TOTAL: 3, // Bảng kê hóa đơn tổng
};

export const TYPE_INVOICE = {
  ADJUST: "ADJUST", // ADJUST
  REPLACE: "REPLACE", // REPLACE
};

export const FILE_NAME_REPORT = {
  ERROR: "ERROR", // type 10,
  DATA: "BẢNG KÊ HÓA ĐƠN ", // Bảng kê dữ liệu hóa đơn,
  USE: "BẢNG KÊ TÌNH HÌNH SỬ DỤNG HÓA ĐƠN ", // Bảng kê tình hình sử dụng
  TOTAL: "BẢNG KÊ HÓA ĐƠN TỔNG ", // Bảng kê hóa đơn tổng
};
